import { render, staticRenderFns } from "./thirdSdk.vue?vue&type=template&id=66beb6e8&scoped=true"
import script from "./thirdSdk.vue?vue&type=script&lang=js"
export * from "./thirdSdk.vue?vue&type=script&lang=js"
import style0 from "./thirdSdk.vue?vue&type=style&index=0&id=66beb6e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66beb6e8",
  null
  
)

export default component.exports